export const ADD_PROSPECT_INFO = 'ADD_PROSPECT_INFO';
export const SELECTED_PROSPECT_NOTES = 'SELECTED_PROSPECT_NOTES';
